import { base_colorAction, base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  transition_slow,
  transition_slower,
} from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 ${spacing(5)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};

  .Subnav-tabs {
    display: flex;
    flex-direction: row;
    gap: ${spacing(6)};
  }

  .Subnav-activeBar {
    position: absolute;
    bottom: -1px;
    height: 2px;
    background-color: ${base_colorAction};
    transition:
      width ${transition_slow} ease-out,
      left ${transition_slower} ease-out;
  }
`
